export function useWatchScreenCapture() {}
